var map = {
	"./af": 22607,
	"./af.d": 44766,
	"./af.d.ts": 44766,
	"./af.js": 22607,
	"./ak": 88124,
	"./ak.d": 16709,
	"./ak.d.ts": 16709,
	"./ak.js": 88124,
	"./am": 89370,
	"./am.d": 2799,
	"./am.d.ts": 2799,
	"./am.js": 89370,
	"./an": 93095,
	"./an.d": 93318,
	"./an.d.ts": 93318,
	"./an.js": 93095,
	"./ar": 34459,
	"./ar.d": 59106,
	"./ar.d.ts": 59106,
	"./ar.js": 34459,
	"./ars": 76014,
	"./ars.d": 26421,
	"./ars.d.ts": 26421,
	"./ars.js": 76014,
	"./as": 86516,
	"./as.d": 20397,
	"./as.d.ts": 20397,
	"./as.js": 86516,
	"./asa": 78573,
	"./asa.d": 76670,
	"./asa.d.ts": 76670,
	"./asa.js": 78573,
	"./ast": 62194,
	"./ast.d": 26125,
	"./ast.d.ts": 26125,
	"./ast.js": 62194,
	"./az": 23475,
	"./az.d": 53514,
	"./az.d.ts": 53514,
	"./az.js": 23475,
	"./bal": 60401,
	"./bal.d": 69630,
	"./bal.d.ts": 69630,
	"./bal.js": 60401,
	"./be": 43589,
	"./be.d": 25884,
	"./be.d.ts": 25884,
	"./be.js": 43589,
	"./bem": 79870,
	"./bem.d": 70213,
	"./bem.d.ts": 70213,
	"./bem.js": 79870,
	"./bez": 14031,
	"./bez.d": 25724,
	"./bez.d.ts": 25724,
	"./bez.js": 14031,
	"./bg": 84099,
	"./bg.d": 93270,
	"./bg.d.ts": 93270,
	"./bg.js": 84099,
	"./bho": 40613,
	"./bho.d": 56294,
	"./bho.d.ts": 56294,
	"./bho.js": 40613,
	"./bm": 77613,
	"./bm.d": 22164,
	"./bm.d.ts": 22164,
	"./bm.js": 77613,
	"./bn": 95556,
	"./bn.d": 41577,
	"./bn.d.ts": 41577,
	"./bn.js": 95556,
	"./bo": 1227,
	"./bo.d": 78190,
	"./bo.d.ts": 78190,
	"./bo.js": 1227,
	"./br": 96256,
	"./br.d": 53477,
	"./br.d.ts": 53477,
	"./br.js": 96256,
	"./brx": 55434,
	"./brx.d": 77385,
	"./brx.d.ts": 77385,
	"./brx.js": 55434,
	"./bs": 95031,
	"./bs.d": 48474,
	"./bs.d.ts": 48474,
	"./bs.js": 95031,
	"./ca": 26656,
	"./ca.d": 19141,
	"./ca.d.ts": 19141,
	"./ca.js": 26656,
	"./ce": 36812,
	"./ce.d": 41409,
	"./ce.d.ts": 41409,
	"./ce.js": 36812,
	"./ceb": 58220,
	"./ceb.d": 25027,
	"./ceb.d.ts": 25027,
	"./ceb.js": 58220,
	"./cgg": 32369,
	"./cgg.d": 63154,
	"./cgg.d.ts": 63154,
	"./cgg.js": 32369,
	"./chr": 21737,
	"./chr.d": 55546,
	"./chr.d.ts": 55546,
	"./chr.js": 21737,
	"./ckb": 30162,
	"./ckb.d": 93997,
	"./ckb.d.ts": 93997,
	"./ckb.js": 30162,
	"./cs": 10810,
	"./cs.d": 82179,
	"./cs.d.ts": 82179,
	"./cs.js": 10810,
	"./cy": 15576,
	"./cy.d": 11533,
	"./cy.d.ts": 11533,
	"./cy.js": 15576,
	"./da": 60515,
	"./da.d": 17530,
	"./da.d.ts": 17530,
	"./da.js": 60515,
	"./de": 86727,
	"./de.d": 33913,
	"./de.d.ts": 33913,
	"./de.js": 86727,
	"./doi": 28662,
	"./doi.d": 31401,
	"./doi.d.ts": 31401,
	"./doi.js": 28662,
	"./dsb": 23911,
	"./dsb.d": 29952,
	"./dsb.d.ts": 29952,
	"./dsb.js": 23911,
	"./dv": 20362,
	"./dv.d": 70463,
	"./dv.d.ts": 70463,
	"./dv.js": 20362,
	"./dz": 5374,
	"./dz.d": 19643,
	"./dz.d.ts": 19643,
	"./dz.js": 5374,
	"./ee": 35774,
	"./ee.d": 54627,
	"./ee.d.ts": 54627,
	"./ee.js": 35774,
	"./el": 79349,
	"./el.d": 40168,
	"./el.d.ts": 40168,
	"./el.js": 79349,
	"./en": 21331,
	"./en.d": 33986,
	"./en.d.ts": 33986,
	"./en.js": 21331,
	"./eo": 21068,
	"./eo.d": 83981,
	"./eo.d.ts": 83981,
	"./eo.js": 21068,
	"./es": 69752,
	"./es.d": 13857,
	"./es.d.ts": 13857,
	"./es.js": 69752,
	"./et": 26957,
	"./et.d": 85664,
	"./et.d.ts": 85664,
	"./et.js": 26957,
	"./eu": 66254,
	"./eu.d": 89683,
	"./eu.d.ts": 89683,
	"./eu.js": 66254,
	"./fa": 39341,
	"./fa.d": 51348,
	"./fa.d.ts": 51348,
	"./fa.js": 39341,
	"./ff": 23608,
	"./ff.d": 51757,
	"./ff.d.ts": 51757,
	"./ff.js": 23608,
	"./fi": 5317,
	"./fi.d": 43548,
	"./fi.d.ts": 43548,
	"./fi.js": 5317,
	"./fil": 83837,
	"./fil.d": 91290,
	"./fil.d.ts": 91290,
	"./fil.js": 83837,
	"./fo": 45863,
	"./fo.d": 85418,
	"./fo.d.ts": 85418,
	"./fo.js": 45863,
	"./fr": 28820,
	"./fr.d": 31737,
	"./fr.d.ts": 31737,
	"./fr.js": 28820,
	"./fur": 93339,
	"./fur.d": 93544,
	"./fur.d.ts": 93544,
	"./fur.js": 93339,
	"./fy": 32309,
	"./fy.d": 89164,
	"./fy.d.ts": 89164,
	"./fy.js": 32309,
	"./ga": 75572,
	"./ga.d": 97401,
	"./ga.d.ts": 97401,
	"./ga.js": 75572,
	"./gd": 70623,
	"./gd.d": 47602,
	"./gd.d.ts": 47602,
	"./gd.js": 70623,
	"./gl": 80215,
	"./gl.d": 12570,
	"./gl.d.ts": 12570,
	"./gl.js": 80215,
	"./gsw": 95145,
	"./gsw.d": 19354,
	"./gsw.d.ts": 19354,
	"./gsw.js": 95145,
	"./gu": 54008,
	"./gu.d": 17421,
	"./gu.d.ts": 17421,
	"./gu.js": 54008,
	"./guw": 66307,
	"./guw.d": 5832,
	"./guw.d.ts": 5832,
	"./guw.js": 66307,
	"./gv": 68337,
	"./gv.d": 42856,
	"./gv.d.ts": 42856,
	"./gv.js": 68337,
	"./ha": 20199,
	"./ha.d": 82878,
	"./ha.d.ts": 82878,
	"./ha.js": 20199,
	"./haw": 26590,
	"./haw.d": 15549,
	"./haw.d.ts": 15549,
	"./haw.js": 26590,
	"./he": 70691,
	"./he.d": 42834,
	"./he.d.ts": 42834,
	"./he.js": 70691,
	"./hi": 41871,
	"./hi.d": 31430,
	"./hi.d.ts": 31430,
	"./hi.js": 41871,
	"./hnj": 67422,
	"./hnj.d": 70269,
	"./hnj.d.ts": 70269,
	"./hnj.js": 67422,
	"./hr": 30538,
	"./hr.d": 7671,
	"./hr.d.ts": 7671,
	"./hr.js": 30538,
	"./hsb": 37811,
	"./hsb.d": 62860,
	"./hsb.d.ts": 62860,
	"./hsb.js": 37811,
	"./hu": 8051,
	"./hu.d": 97218,
	"./hu.d.ts": 97218,
	"./hu.js": 8051,
	"./hy": 98207,
	"./hy.d": 57942,
	"./hy.d.ts": 57942,
	"./hy.js": 98207,
	"./ia": 61334,
	"./ia.d": 45043,
	"./ia.d.ts": 45043,
	"./ia.js": 61334,
	"./id": 47545,
	"./id.d": 27276,
	"./id.d.ts": 27276,
	"./id.js": 47545,
	"./ig": 13248,
	"./ig.d": 88993,
	"./ig.d.ts": 88993,
	"./ig.js": 13248,
	"./ii": 38110,
	"./ii.d": 49163,
	"./ii.d.ts": 49163,
	"./ii.js": 38110,
	"./io": 33640,
	"./io.d": 69849,
	"./io.d.ts": 69849,
	"./io.js": 33640,
	"./is": 3100,
	"./is.d": 32629,
	"./is.d.ts": 32629,
	"./is.js": 3100,
	"./it": 94089,
	"./it.d": 81660,
	"./it.d.ts": 81660,
	"./it.js": 94089,
	"./iu": 23578,
	"./iu.d": 76863,
	"./iu.d.ts": 76863,
	"./iu.js": 23578,
	"./ja": 31761,
	"./ja.d": 62968,
	"./ja.d.ts": 62968,
	"./ja.js": 31761,
	"./jbo": 66171,
	"./jbo.d": 48400,
	"./jbo.d.ts": 48400,
	"./jbo.js": 66171,
	"./jgo": 17306,
	"./jgo.d": 62037,
	"./jgo.d.ts": 62037,
	"./jgo.js": 17306,
	"./jmc": 36640,
	"./jmc.d": 28343,
	"./jmc.d.ts": 28343,
	"./jmc.js": 36640,
	"./jv": 73684,
	"./jv.d": 45353,
	"./jv.d.ts": 45353,
	"./jv.js": 73684,
	"./jw": 21627,
	"./jw.d": 81966,
	"./jw.d.ts": 81966,
	"./jw.js": 21627,
	"./ka": 36232,
	"./ka.d": 9197,
	"./ka.d.ts": 9197,
	"./ka.js": 36232,
	"./kab": 8720,
	"./kab.d": 33767,
	"./kab.d.ts": 33767,
	"./kab.js": 8720,
	"./kaj": 50808,
	"./kaj.d": 55727,
	"./kaj.d.ts": 55727,
	"./kaj.js": 50808,
	"./kcg": 42845,
	"./kcg.d": 15729,
	"./kcg.d.ts": 15729,
	"./kcg.js": 42845,
	"./kde": 24936,
	"./kde.d": 22763,
	"./kde.d.ts": 22763,
	"./kde.js": 24936,
	"./kea": 21325,
	"./kea.d": 33410,
	"./kea.d.ts": 33410,
	"./kea.js": 21325,
	"./kk": 37354,
	"./kk.d": 69059,
	"./kk.d.ts": 69059,
	"./kk.js": 37354,
	"./kkj": 10018,
	"./kkj.d": 21581,
	"./kkj.d.ts": 21581,
	"./kkj.js": 10018,
	"./kl": 57395,
	"./kl.d": 92278,
	"./kl.d.ts": 92278,
	"./kl.js": 57395,
	"./km": 91308,
	"./km.d": 64369,
	"./km.d.ts": 64369,
	"./km.js": 91308,
	"./kn": 72885,
	"./kn.d": 10492,
	"./kn.d.ts": 10492,
	"./kn.js": 72885,
	"./ko": 63926,
	"./ko.d": 33983,
	"./ko.d.ts": 33983,
	"./ko.js": 63926,
	"./ks": 10626,
	"./ks.d": 97771,
	"./ks.d.ts": 97771,
	"./ks.js": 10626,
	"./ksb": 24994,
	"./ksb.d": 84493,
	"./ksb.d.ts": 84493,
	"./ksb.js": 24994,
	"./ksh": 36464,
	"./ksh.d": 55139,
	"./ksh.d.ts": 55139,
	"./ksh.js": 36464,
	"./ku": 38436,
	"./ku.d": 81337,
	"./ku.d.ts": 81337,
	"./ku.js": 38436,
	"./kw": 52846,
	"./kw.d": 7335,
	"./kw.d.ts": 7335,
	"./kw.js": 52846,
	"./ky": 2864,
	"./ky.d": 89157,
	"./ky.d.ts": 89157,
	"./ky.js": 2864,
	"./lag": 60930,
	"./lag.d": 92737,
	"./lag.d.ts": 92737,
	"./lag.js": 60930,
	"./lb": 85518,
	"./lb.d": 86555,
	"./lb.d.ts": 86555,
	"./lb.js": 85518,
	"./lg": 93777,
	"./lg.d": 98388,
	"./lg.d.ts": 98388,
	"./lg.js": 93777,
	"./lij": 97565,
	"./lij.d": 73306,
	"./lij.d.ts": 73306,
	"./lij.js": 97565,
	"./lkt": 68389,
	"./lkt.d": 96918,
	"./lkt.d.ts": 96918,
	"./lkt.js": 68389,
	"./ln": 97978,
	"./ln.d": 16543,
	"./ln.d.ts": 16543,
	"./ln.js": 97978,
	"./lo": 45193,
	"./lo.d": 2108,
	"./lo.d.ts": 2108,
	"./lo.js": 45193,
	"./lt": 68392,
	"./lt.d": 90297,
	"./lt.d.ts": 90297,
	"./lt.js": 68392,
	"./lv": 44626,
	"./lv.d": 25127,
	"./lv.d.ts": 25127,
	"./lv.js": 44626,
	"./mas": 19977,
	"./mas.d": 84662,
	"./mas.d.ts": 84662,
	"./mas.js": 19977,
	"./mg": 92220,
	"./mg.d": 79741,
	"./mg.d.ts": 79741,
	"./mg.js": 92220,
	"./mgo": 80591,
	"./mgo.d": 16336,
	"./mgo.d.ts": 16336,
	"./mgo.js": 80591,
	"./mk": 26520,
	"./mk.d": 17633,
	"./mk.d.ts": 17633,
	"./mk.js": 26520,
	"./ml": 67373,
	"./ml.d": 89440,
	"./ml.d.ts": 89440,
	"./ml.js": 67373,
	"./mn": 24235,
	"./mn.d": 90362,
	"./mn.d.ts": 90362,
	"./mn.js": 24235,
	"./mo": 42788,
	"./mo.d": 95365,
	"./mo.d.ts": 95365,
	"./mo.js": 42788,
	"./mr": 66455,
	"./mr.d": 20078,
	"./mr.d.ts": 20078,
	"./mr.js": 66455,
	"./ms": 76736,
	"./ms.d": 83465,
	"./ms.d.ts": 83465,
	"./ms.js": 76736,
	"./mt": 19765,
	"./mt.d": 43944,
	"./mt.d.ts": 43944,
	"./mt.js": 19765,
	"./my": 68402,
	"./my.d": 82207,
	"./my.d.ts": 82207,
	"./my.js": 68402,
	"./nah": 18161,
	"./nah.d": 89510,
	"./nah.d.ts": 89510,
	"./nah.js": 18161,
	"./naq": 93354,
	"./naq.d": 80489,
	"./naq.d.ts": 80489,
	"./naq.js": 93354,
	"./nb": 8236,
	"./nb.d": 96593,
	"./nb.d.ts": 96593,
	"./nb.js": 8236,
	"./nd": 54282,
	"./nd.d": 66211,
	"./nd.d.ts": 66211,
	"./nd.js": 54282,
	"./ne": 43769,
	"./ne.d": 41424,
	"./ne.d.ts": 41424,
	"./ne.js": 43769,
	"./nl": 15154,
	"./nl.d": 92091,
	"./nl.d.ts": 92091,
	"./nl.js": 15154,
	"./nn": 87336,
	"./nn.d": 75597,
	"./nn.d.ts": 75597,
	"./nn.js": 87336,
	"./nnh": 27266,
	"./nnh.d": 52737,
	"./nnh.d.ts": 52737,
	"./nnh.js": 27266,
	"./no": 21951,
	"./no.d": 68354,
	"./no.d.ts": 68354,
	"./no.js": 21951,
	"./nqo": 73140,
	"./nqo.d": 14563,
	"./nqo.d.ts": 14563,
	"./nqo.js": 73140,
	"./nr": 38972,
	"./nr.d": 66337,
	"./nr.d.ts": 66337,
	"./nr.js": 38972,
	"./nso": 35186,
	"./nso.d": 56541,
	"./nso.d.ts": 56541,
	"./nso.js": 35186,
	"./ny": 14125,
	"./ny.d": 4324,
	"./ny.d.ts": 4324,
	"./ny.js": 14125,
	"./nyn": 74659,
	"./nyn.d": 67016,
	"./nyn.d.ts": 67016,
	"./nyn.js": 74659,
	"./om": 10776,
	"./om.d": 45021,
	"./om.d.ts": 45021,
	"./om.js": 10776,
	"./or": 19477,
	"./or.d": 73308,
	"./or.d.ts": 73308,
	"./or.js": 19477,
	"./os": 27414,
	"./os.d": 24927,
	"./os.d.ts": 24927,
	"./os.js": 27414,
	"./osa": 59115,
	"./osa.d": 36020,
	"./osa.d.ts": 36020,
	"./osa.js": 59115,
	"./pa": 81967,
	"./pa.d": 16358,
	"./pa.d.ts": 16358,
	"./pa.js": 81967,
	"./pap": 38263,
	"./pap.d": 75132,
	"./pap.d.ts": 75132,
	"./pap.js": 38263,
	"./pcm": 25514,
	"./pcm.d": 10613,
	"./pcm.d.ts": 10613,
	"./pcm.js": 25514,
	"./pl": 13308,
	"./pl.d": 31741,
	"./pl.d.ts": 31741,
	"./pl.js": 13308,
	"./prg": 62429,
	"./prg.d": 44706,
	"./prg.d.ts": 44706,
	"./prg.js": 62429,
	"./ps": 80417,
	"./ps.d": 19772,
	"./ps.d.ts": 19772,
	"./ps.js": 80417,
	"./pt": 52820,
	"./pt-PT": 35797,
	"./pt-PT.d": 49046,
	"./pt-PT.d.ts": 49046,
	"./pt-PT.js": 35797,
	"./pt.d": 70741,
	"./pt.d.ts": 70741,
	"./pt.js": 52820,
	"./rm": 51549,
	"./rm.d": 93860,
	"./rm.d.ts": 93860,
	"./rm.js": 51549,
	"./ro": 36603,
	"./ro.d": 55326,
	"./ro.d.ts": 55326,
	"./ro.js": 36603,
	"./rof": 3809,
	"./rof.d": 40546,
	"./rof.d.ts": 40546,
	"./rof.js": 3809,
	"./ru": 97221,
	"./ru.d": 48604,
	"./ru.d.ts": 48604,
	"./ru.js": 97221,
	"./rwk": 81598,
	"./rwk.d": 23337,
	"./rwk.d.ts": 23337,
	"./rwk.js": 81598,
	"./sah": 66090,
	"./sah.d": 75529,
	"./sah.d.ts": 75529,
	"./sah.js": 66090,
	"./saq": 64721,
	"./saq.d": 18726,
	"./saq.d.ts": 18726,
	"./saq.js": 64721,
	"./sat": 81582,
	"./sat.d": 71077,
	"./sat.d.ts": 71077,
	"./sat.js": 81582,
	"./sc": 80058,
	"./sc.d": 61091,
	"./sc.d.ts": 61091,
	"./sc.js": 80058,
	"./scn": 43550,
	"./scn.d": 90121,
	"./scn.d.ts": 90121,
	"./scn.js": 43550,
	"./sd": 60451,
	"./sd.d": 59190,
	"./sd.d.ts": 59190,
	"./sd.js": 60451,
	"./sdh": 25179,
	"./sdh.d": 38676,
	"./sdh.d.ts": 38676,
	"./sdh.js": 25179,
	"./se": 78812,
	"./se.d": 209,
	"./se.d.ts": 209,
	"./se.js": 78812,
	"./seh": 63406,
	"./seh.d": 73117,
	"./seh.d.ts": 73117,
	"./seh.js": 63406,
	"./ses": 26323,
	"./ses.d": 48976,
	"./ses.d.ts": 48976,
	"./ses.js": 26323,
	"./sg": 90278,
	"./sg.d": 49311,
	"./sg.d.ts": 49311,
	"./sg.js": 90278,
	"./sh": 96943,
	"./sh.d": 81570,
	"./sh.d.ts": 81570,
	"./sh.js": 96943,
	"./shi": 82488,
	"./shi.d": 31723,
	"./shi.d.ts": 31723,
	"./shi.js": 82488,
	"./si": 62584,
	"./si.d": 62317,
	"./si.d.ts": 62317,
	"./si.js": 62584,
	"./sk": 51042,
	"./sk.d": 10427,
	"./sk.d.ts": 10427,
	"./sk.js": 51042,
	"./sl": 94475,
	"./sl.d": 63886,
	"./sl.d.ts": 63886,
	"./sl.js": 94475,
	"./sma": 2429,
	"./sma.d": 85954,
	"./sma.d.ts": 85954,
	"./sma.js": 2429,
	"./smi": 68149,
	"./smi.d": 26314,
	"./smi.d.ts": 26314,
	"./smi.js": 68149,
	"./smj": 61452,
	"./smj.d": 83811,
	"./smj.d.ts": 83811,
	"./smj.js": 61452,
	"./smn": 67648,
	"./smn.d": 99244,
	"./smn.d.ts": 99244,
	"./smn.js": 67648,
	"./sms": 72619,
	"./sms.d": 26488,
	"./sms.d.ts": 26488,
	"./sms.js": 72619,
	"./sn": 19789,
	"./sn.d": 61908,
	"./sn.d.ts": 61908,
	"./sn.js": 19789,
	"./so": 93262,
	"./so.d": 34775,
	"./so.d.ts": 34775,
	"./so.js": 93262,
	"./sq": 89504,
	"./sq.d": 39173,
	"./sq.d.ts": 39173,
	"./sq.js": 89504,
	"./sr": 6905,
	"./sr.d": 70944,
	"./sr.d.ts": 70944,
	"./sr.js": 6905,
	"./ss": 94122,
	"./ss.d": 17491,
	"./ss.d.ts": 17491,
	"./ss.js": 94122,
	"./ssy": 18111,
	"./ssy.d": 12232,
	"./ssy.d.ts": 12232,
	"./ssy.js": 18111,
	"./st": 14163,
	"./st.d": 50694,
	"./st.d.ts": 50694,
	"./st.js": 14163,
	"./su": 48076,
	"./su.d": 61441,
	"./su.d.ts": 61441,
	"./su.js": 48076,
	"./sv": 29653,
	"./sv.d": 99724,
	"./sv.d.ts": 99724,
	"./sv.js": 29653,
	"./sw": 20694,
	"./sw.d": 76527,
	"./sw.d.ts": 76527,
	"./sw.js": 20694,
	"./syr": 16160,
	"./syr.d": 72487,
	"./syr.d.ts": 72487,
	"./syr.js": 16160,
	"./ta": 44563,
	"./ta.d": 36522,
	"./ta.d.ts": 36522,
	"./ta.js": 44563,
	"./te": 25975,
	"./te.d": 19190,
	"./te.d.ts": 19190,
	"./te.js": 25975,
	"./teo": 36246,
	"./teo.d": 94605,
	"./teo.d.ts": 94605,
	"./teo.js": 36246,
	"./th": 7604,
	"./th.d": 19757,
	"./th.d.ts": 19757,
	"./th.js": 7604,
	"./ti": 55547,
	"./ti.d": 58466,
	"./ti.d.ts": 58466,
	"./ti.js": 55547,
	"./tig": 42034,
	"./tig.d": 22369,
	"./tig.d.ts": 22369,
	"./tig.js": 42034,
	"./tk": 19453,
	"./tk.d": 45192,
	"./tk.d.ts": 45192,
	"./tk.js": 19453,
	"./tl": 23400,
	"./tl.d": 76553,
	"./tl.d.ts": 76553,
	"./tl.js": 23400,
	"./tn": 8690,
	"./tn.d": 52567,
	"./tn.d.ts": 52567,
	"./tn.js": 8690,
	"./to": 92673,
	"./to.d": 13716,
	"./to.d.ts": 13716,
	"./to.js": 92673,
	"./tpi": 41837,
	"./tpi.d": 8286,
	"./tpi.d.ts": 8286,
	"./tpi.js": 41837,
	"./tr": 37030,
	"./tr.d": 51635,
	"./tr.d.ts": 51635,
	"./tr.js": 37030,
	"./ts": 38949,
	"./ts.d": 192,
	"./ts.d.ts": 192,
	"./ts.js": 38949,
	"./tzm": 87807,
	"./tzm.d": 99420,
	"./tzm.d.ts": 99420,
	"./tzm.js": 87807,
	"./ug": 292,
	"./ug.d": 65381,
	"./ug.d.ts": 65381,
	"./ug.js": 292,
	"./uk": 47824,
	"./uk.d": 57561,
	"./uk.d.ts": 57561,
	"./uk.js": 47824,
	"./und": 94423,
	"./und.d": 52380,
	"./und.d.ts": 52380,
	"./und.js": 94423,
	"./ur": 90175,
	"./ur.d": 84854,
	"./ur.d.ts": 84854,
	"./ur.js": 90175,
	"./uz": 16119,
	"./uz.d": 48078,
	"./uz.d.ts": 48078,
	"./uz.js": 16119,
	"./ve": 32449,
	"./ve.d": 96312,
	"./ve.d.ts": 96312,
	"./ve.js": 32449,
	"./vi": 64597,
	"./vi.d": 38700,
	"./vi.d.ts": 38700,
	"./vi.js": 64597,
	"./vo": 46519,
	"./vo.d": 93754,
	"./vo.d.ts": 93754,
	"./vo.js": 46519,
	"./vun": 17367,
	"./vun.d": 79452,
	"./vun.d.ts": 79452,
	"./vun.js": 17367,
	"./wa": 76708,
	"./wa.d": 55913,
	"./wa.d.ts": 55913,
	"./wa.js": 76708,
	"./wae": 58081,
	"./wae.d": 38638,
	"./wae.d.ts": 38638,
	"./wae.js": 58081,
	"./wo": 4090,
	"./wo.d": 47203,
	"./wo.d.ts": 47203,
	"./wo.js": 4090,
	"./xh": 76648,
	"./xh.d": 72817,
	"./xh.d.ts": 72817,
	"./xh.js": 76648,
	"./xog": 85140,
	"./xog.d": 19151,
	"./xog.d.ts": 19151,
	"./xog.js": 85140,
	"./yi": 14926,
	"./yi.d": 97115,
	"./yi.d.ts": 97115,
	"./yi.js": 14926,
	"./yo": 34776,
	"./yo.d": 44713,
	"./yo.d.ts": 44713,
	"./yo.js": 34776,
	"./yue": 46243,
	"./yue.d": 34840,
	"./yue.d.ts": 34840,
	"./yue.js": 46243,
	"./zh": 62538,
	"./zh.d": 99203,
	"./zh.d.ts": 99203,
	"./zh.js": 62538,
	"./zu": 6029,
	"./zu.d": 46052,
	"./zu.d.ts": 46052,
	"./zu.js": 6029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99112;